import { io, Socket } from 'socket.io-client';
import { ServerToClientEvents, ClientToServerEvents } from './types/Socket';

const getServerUrl = (): string => {
  if (process.env.REACT_APP_SERVER_URL) return process.env.REACT_APP_SERVER_URL;
  // Derive from the current page host so mobile/LAN devices reach the right server
  const { protocol, hostname } = window.location;
  return `${protocol}//${hostname}:3001`;
};

export const socket: Socket<ServerToClientEvents, ClientToServerEvents> = io(getServerUrl(), {
  autoConnect: false,
  transports: ['websocket'],
  upgrade: false,
  rememberUpgrade: true,
  reconnection: true,
  reconnectionAttempts: 10,
  reconnectionDelay: 500,
  reconnectionDelayMax: 2000,
  timeout: 8000,
});

export const connectSocket = (): void => {
  if (!socket.connected) socket.connect();
};

export const disconnectSocket = (): void => {
  if (socket.connected) socket.disconnect();
};
